import styled from 'styled-components';

export const MatchesTable = styled.div`
    flex: 2;
    width: 100%;
    height: 250px;
    background-color: #d5dec8;
    display: flex;
    align-items: center;
    flex-direction: column;
    clip-path: polygon(0 0, 100% 0, 100% 100%, 20% 100%);
    margin-top: -30px;
    position: relative;
    user-select: none;
    min-width: 440px;
    
    @media (max-width: 1337px) {
        clip-path: none;
        border-top-left-radius: 50px;
        border-bottom-left-radius: 50px;
    }
    
    @media (max-width: 880px) {
        clip-path: none;
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
    }
    
    @media (max-width: 440px) {
        min-width: inherit;
    }
`;

export const TableHeader = styled.p`
    font-family: BlenderProBold, serif;
    font-size: 13px;
    color: black;   
    letter-spacing: 1px; 
    margin-bottom: 30px;
`;

export const TableSubheader = styled.p`
    font-family: BlenderProBold, serif;
    font-size: 11px;
    color: black;   
    letter-spacing: 1px; 
    margin-bottom: 30px;
`;

export const CategoryContainer = styled.div`
    background-position: center;
    background-size: cover;
    background-attachment: fixed;
    background-repeat: no-repeat;
    background-image: url(${({url}) => url});
    width: 100%;
    z-index: 1;
    margin-top: 80px;
    margin-bottom: 20px;
    border-top: 2px solid darkblue;
    border-bottom: 2px solid darkgreen;
`;

export const CategoryContainerContent = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background-color: #00000099;
    width: 100%;
    height: 100%;
    position: relative;
    padding-bottom: 50px;
`;

export const CategoryBackgroundWrapper = styled.div`
    background-color: #00000070;
    width: 100%;
    height: 100%;
`;

export const Categories = styled.div`
    width: 80%;
    display: flex;
    flex-direction: row; 
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
`;

export const MatchesInfoText = styled.p`
    font-family: Roboto Condensed, serif;
    font-size: 14px;    
`;
